import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=61106e4a"
import script from "./Social.vue?vue&type=script&lang=ts"
export * from "./Social.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports